import React from "react";
import styled from "styled-components";

import Member from "./Member";
import { ADVISORS } from "../../constants/team";
import { Highlight, H2Styled as Header } from "../../shared/Headers";
import { SectionMesh as Section } from "../../shared/Refactor/Sections";
import { Grid } from "../../shared/Refactor/Lists";

const Container = styled(Grid)`
  grid-gap: 2em 0;
  display: grid;
  justify-content: center;
  @media (min-width: 500px) {
    justify-content: space-between;
    grid-template-columns: repeat(2, auto);
  }
  @media (min-width: 768px) {
    grid-template-columns: repeat(3, auto);
    width: 80%;
  }
  @media (min-width: 1280px) {
    grid-template-columns: repeat(4, auto);
    width: 55%;
  }
  @media (min-width: 1500px) {
    grid-template-columns: repeat(5, auto);
    width: 65%;
  }
`;

const Advisors = () => {
  return (
    <Section hash="team">
      <Header>
        Our <br />
        <Highlight>Advisors</Highlight>
      </Header>
      <Container>
        {ADVISORS.map((team, idx) => {
          return (
            <Member
              key={team.name}
              name={team.name}
              title={team.title}
              img={team.image}
            />
          );
        })}
      </Container>
    </Section>
  );
};

export default Advisors;
